exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.disabled[data-v-56d0b499] {\n  background-color: #ffffff;\n}\n", ""]);

